import { useEffect } from "react"
import { useLocation } from "react-router-dom"

interface SEOProps {
    title: string
    description: string
    jsonLd?: object
}

const BASE_URL = "https://puhony.eu"

const SEO = ({ title, description, jsonLd }: SEOProps) => {
    const location = useLocation()
    const fullUrl = `${BASE_URL}${location.pathname}`
    const fullTitle = `${title} | Matěj Půhoný`

    useEffect(() => {
        document.title = fullTitle

        const setMeta = (attr: string, key: string, content: string) => {
            let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null
            if (!el) {
                el = document.createElement("meta")
                el.setAttribute(attr, key)
                document.head.appendChild(el)
            }
            el.setAttribute("content", content)
        }

        setMeta("name", "description", description)
        setMeta("name", "title", fullTitle)
        setMeta("property", "og:title", fullTitle)
        setMeta("property", "og:description", description)
        setMeta("property", "og:url", fullUrl)
        setMeta("name", "twitter:title", fullTitle)
        setMeta("name", "twitter:description", description)
        setMeta("name", "twitter:url", fullUrl)

        let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null
        if (!canonical) {
            canonical = document.createElement("link")
            canonical.setAttribute("rel", "canonical")
            document.head.appendChild(canonical)
        }
        canonical.setAttribute("href", fullUrl)

        let jsonLdScript = document.getElementById("page-jsonld") as HTMLScriptElement | null
        if (jsonLd) {
            if (!jsonLdScript) {
                jsonLdScript = document.createElement("script")
                jsonLdScript.id = "page-jsonld"
                jsonLdScript.type = "application/ld+json"
                document.head.appendChild(jsonLdScript)
            }
            jsonLdScript.textContent = JSON.stringify(jsonLd)
        } else if (jsonLdScript) {
            jsonLdScript.remove()
        }

        return () => {
            if (jsonLdScript) {
                jsonLdScript.remove()
            }
        }
    }, [fullTitle, description, fullUrl, jsonLd])

    return null
}

export default SEO
